import { useState } from "react"
import { useTranslation } from "react-i18next"
import { ChatMessageTranslationFailed } from "@/modules/chats/components/chat-message/chat-message-translation-failed"
import { renderMessageLines } from "@/modules/chats/components/chat-message/render-message-lines"

export const AutoTranslatedPatientMessageContent = (props: {
  patientOriginalContent: string
  autoTranslatedContent?: string
  hasTranslationFailed?: boolean
  patientLanguageCode?: string
}) => {
  const { t } = useTranslation()
  const [isTranslationDetailVisible, setIsTranslationDetailVisible] = useState(false)

  if (props.hasTranslationFailed) {
    return (
      <div className="grid h-fit gap-1 text-sm" data-testid="chat-message-from-patient">
        {renderMessageLines(props.patientOriginalContent)}
        <ChatMessageTranslationFailed />
      </div>
    )
  }

  return (
    <div className="grid h-fit gap-1 text-sm" data-testid="chat-message-from-patient">
      {renderMessageLines(props.autoTranslatedContent ?? "")}
      {isTranslationDetailVisible && props.patientOriginalContent && (
        <div className="grid gap-0.5">
          <span className="bg-primary-surface text-on-primary-surface w-fit rounded px-1.5 py-0.5 text-xs tracking-[0.25px]">
            {t("chat.autoTranslation.original", { language: props.patientLanguageCode })}
          </span>
          {renderMessageLines(props.patientOriginalContent, "text-on-surface-subdued text-xs")}
        </div>
      )}
      <button
        className="text-primary w-fit cursor-pointer text-left text-xs hover:underline"
        onClick={() => setIsTranslationDetailVisible((previous) => !previous)}>
        {isTranslationDetailVisible
          ? t("chat.autoTranslation.hideTranslation")
          : t("chat.autoTranslation.showTranslation")}
      </button>
    </div>
  )
}
